import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./styles/DashboardPage.css";
import Clock from "../../components/Clock";
import CircularProgressBar from "../../components/CircularProgressBar";
import AreaChartComponent from "../../components/AreaChart";
import WaterLevel from "../../components/waterLevel";
import Weather from "../../components/Weather";
import MaintenanceTracker from "../../components/MaintenanceTracker";
import PoleStatus from "../../components/PoleStatus";
import arrowR from "/assets/ArrowR.svg";
import WaterLeveltitle from "/Group.png?url";
import Vector from "/assets/Vector.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

const getCurrentTimeGreeting = () => {
  const currentTime = new Date();
  const hours = currentTime.getHours();

  if (hours >= 5 && hours < 12) {
    return "สวัสดีตอนเช้า";
  } else if (hours >= 12 && hours < 18) {
    return "สวัสดีตอนกลางวัน";
  } else {
    return "สวัสดีตอนเย็น";
  }
};

const Dashboard = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState({});
  const [selectedBranch] = useState(sessionStorage.getItem("selectedBranch"));
  const [loading, setLoading] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const updateUnreadCount = () => {
      const storedData =
        JSON.parse(sessionStorage.getItem("auditRecords")) || [];
      const storedViewedStates =
        JSON.parse(sessionStorage.getItem("viewedStates")) || {};
      const unreadRecords = storedData.filter(
        (record, index) => !storedViewedStates[index]
      );
      setUnreadCount(unreadRecords.length);
    };

    updateUnreadCount();
    const intervalId = setInterval(updateUnreadCount, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (selectedBranch) {
      axios
        .get(
          `${
            import.meta.env.VITE_API_URL
          }/api/countActivePolesAndUsersByBranchName/${encodeURIComponent(
            selectedBranch
          )}`
        )
        .then((response) => {
          setCount(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    } else {
      console.log("No selected branch found in sessionStorage.");
      setLoading(false);
    }
  }, [selectedBranch]);

  const percentage = Math.floor(Math.random() * 100) + 1;
  const waterLevel = Math.floor(Math.random() * 100) + 1;
  const currentWaterLevel = Math.floor(Math.random() * 100) + 1;

  const handleAlertClick = () => {
    // เคลียร์ unreadCount และตั้งค่าสถานะ viewedStates เป็น true
    const storedData = JSON.parse(sessionStorage.getItem("auditRecords")) || [];
    const viewedStates = storedData.reduce((acc, _, index) => {
      acc[index] = true;
      return acc;
    }, {});
    sessionStorage.setItem("viewedStates", JSON.stringify(viewedStates));
    setUnreadCount(0);

    // นำทางไปยังหน้า /alert
    navigate("/alert");
  };

  return (
    <>
      <div className="dashboard-container">
        <br />
        <div className="titleDashboard">
          <h1 className="greeting">{getCurrentTimeGreeting()}</h1>

          <h2 className="date-time">
            <Clock />
          </h2>
        </div>

        <div className="titleDashboardSection">
          <div className="polestatus-container">
            <div className="polestatus1">
              <li className="poleli">สถานะการใช้งานเสา</li>
              <div className="poleStatus">
                <PoleStatus isOnline={true} />
              </div>

              <div className="polestatus-in1">เสาหลัก </div>
              <div className="polestatus-in2">เสารอง </div>

              <li className="user1">
                {loading ? "Loading..." : count.countMasterPoleActive}
              </li>
              <li className="user2">
                {loading ? "Loading..." : count.countPoleActive}
              </li>
            </div>

            <div className="polestatus-offline">
              <div className="polestatus2">
                <li className="poleli">สถานะการใช้งานเสา</li>
                <div className="poleStatus">
                  <PoleStatus isOnline={false} />
                </div>
                <div className="polestatus-in1">เสาหลัก </div>
                <div className="polestatus-in2">เสารอง </div>

                <li className="user1">
                  {loading ? "Loading..." : count.countMasterPoleInactive}
                </li>
                <li className="user2">
                  {loading ? "Loading..." : count.countPoleInactive}
                </li>
              </div>
            </div>

            <div className="polestatus3">
              <li className="poleli">ผู้ใช้งานในสาขา</li>

              <div className="poleStatus">
                <PoleStatus isOnline={true} />
              </div>

              <div className="polestatus-in3">ผู้ใช้งานในระบบ </div>
              <li className="user1">
                <img src={Vector} alt="Vector" />
                {loading ? "Loading..." : count.countActiveUsers}
              </li>
            </div>
            <Link to="/alert">
              <div className="polestatus4" onClick={handleAlertClick}>
                <li>
                  <FontAwesomeIcon icon={faBell} />
                  {unreadCount > 0 ? (
                    <>
                      &nbsp; การแจ้งเตือนใหม่
                      <span className="notification-badge-dashboard"></span>
                      <p className="notification-text">
                        {unreadCount} แจ้งเตือน
                      </p>
                    </>
                  ) : (
                    <span className="no-notification-text">
                      ไม่มีการแจ้งเตือนใหม่
                    </span>
                  )}
                </li>
                <img src={arrowR} alt="arrow" />
              </div>
            </Link>
          </div>
        </div>

        <div className="dashboard-sections">
          <div className="area-chart-container">
            <Weather />
          </div>

          <div className="area-chart-container">
            <div className="waterleve-ltitle">
              <img src={WaterLeveltitle} alt="WaterLeveltitle" />
              <div className="kabab">
                <label
                  style={{
                    fontWeight: "bold",
                    color: "#344054",
                    cursor: "pointer",
                  }}
                >
                  {" "}
                  &#8942;
                </label>
              </div>
              <p>ระดับน้ำ</p>
            </div>
            <li className="waterli">
              <WaterLevel
                waterLevel={waterLevel}
                currentWaterLevel={currentWaterLevel}
              />
            </li>
          </div>

          <div className="area-chart-container">
            <div className="kabab">&#8942;</div>
            <p className="energy-saving-title">ประหยัดพลังงาน</p>

            <CircularProgressBar percentage={percentage} />
            <div className="energy-saving-info-div">
              <p className="energy-saving-info">
                ประหยัดพลังงานไปแล้ว {percentage}%
              </p>
            </div>
          </div>
        </div>

        <div className="dashboard-sections1">
          <div className="area-chart-container">
            <h1 className="area-chart-title">ติดตามการซ่อมบำรุง</h1>
            <MaintenanceTracker />
          </div>

          <div className="area-chart-container">
            <h1 className="area-chart-title">การใช้พลังงาน</h1>
            <AreaChartComponent />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
